import React from 'react';
import Link from 'gatsby-link';
import content from '../content.json';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import MobileNavigation from '../components/MobileNavigation';
import getAncestors from '../scripts/getAncestors';
import BreadCrumbs from '../components/BreadCrumbs';

const IndexPage = (props) => {
  const { pathContext, data } = props;
  const random = Math.floor((Math.random() * 100) + 1);
  const imgUrl = `https://picsum.photos/1920/700?random&raa=${random}`;
  const ancestors = getAncestors(pathContext, data.allSitePage);
  return (
    <div>
      <div className="sr-only">
        <div id="pageContext"
        data-page={pathContext.index}></div>
      </div>
      <Header pages={data.allSitePage} pathContext={pathContext} />
        <div className="body">
          <div className="overlay"></div>
          <div className="navigation">
            <div className="navigation-links">
              <div className="close"></div>
              <Navigation pages={data.allSitePage} pathContext={pathContext} />
            </div>
          </div>
          <div className="content">
          <div className="container">
            <div className="breadcrumbs-container">
              <div className="row">
                <div className="col-12">

                { pathContext.index ? 
                    <a href="#" className="" id="hamburger" data-page={pathContext.index}>
                      <span className="line"></span>
                      <span className="line"></span>
                      <span className="line"></span>
                    </a>: null}

                  <BreadCrumbs ancestors={ancestors} pathContext={pathContext} />

                </div>
              </div>
            </div>
            </div>
            <div className="container-fluid">
              <div className="hero-container">
                <img src={imgUrl} className="img-fluid hero" width="1920px" height="700px"/>
              </div>
            </div>
            <div className="container">
              <div className="row">
              <div className="col-12">
                <div className="title">
                  <h1>{pathContext.title || 'Bienvenue'}</h1>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est enim effectrix multarum et magnarum voluptatum. Neque solum ea communia, verum etiam paria esse dixerunt. Legimus tamen Diogenem, Antipatrum, Mnesarchum, Panaetium, multos alios in primisque familiarem nostrum Posidonium. Quam nemo umquam voluptatem appellavit, appellat; Quas enim kakaw Graeci appellant, vitia malo quam malitias nominare. 
                </p>  
                <p>
                  Habent enim et bene longam et satis litigiosam disputationem. Mihi vero, inquit, placet agi subtilius et, ut ipse dixisti, pressius. Quid enim de amicitia statueris utilitatis causa expetenda vides. Cum praesertim illa perdiscere ludus esset. Quid est, quod ab ea absolvi et perfici debeat? Huius ego nunc auctoritatem sequens idem faciam. Qui-vere falsone, quaerere mittimus-dicitur oculis se privasse; Eam si varietatem diceres, intellegerem, ut etiam non dicente te intellego; Negat enim summo bono afferre incrementum diem. 
                </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="mobile-nav">
          <div className="mobile-overlay"></div>
          <div className="navigation">
            <MobileNavigation pages={data.allSitePage} pathContext={pathContext} />
          </div>
          <div className="bottom">

            <div className="breadcrumbs-container">
              { ancestors.length > 0 ?
               
              <div>
                <BreadCrumbs ancestors={ancestors} pathContext={pathContext} /> 
              </div>
              : 
              <div>
                <div className="breadcrumbs">
                  <div className="crumb">
                    Accueil
                  </div>
                </div>
                </div>}
            </div>

            <a href="#" className="toggle">Menu 
              <div className="hamburger">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>

          </div>
        </div>
      </div>
  );
}

export default IndexPage

export const query = graphql`
  query allPagesQuery {
    allSitePage(
          filter: {context: {type: {eq: "dynamicPage"}}}
    ) {
      edges {
        node {
          id
          path
          layout
          context {
            title
            content
            type
            index
            parent
            hasChildren
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/index.js